import React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

/**
 * Generic "no permission" placeholder for dashboard pages/sections.
 *
 * Used when an API call returns 403. Permissions are not known client-side,
 * so this is rendered reactively. Callers pass already-translated strings.
 */
export default function PermissionDenied({ title, message }) {
  return (
    <Stack
      flex={1}
      alignItems="center"
      justifyContent="center"
      spacing={2}
      sx={{ py: 6, textAlign: 'center' }}
    >
      <LockOutlinedIcon color="disabled" sx={{ fontSize: 48 }} />
      {title && <Typography variant="h6">{title}</Typography>}
      {message && (
        <Typography color="text.secondary" sx={{ maxWidth: 420 }}>
          {message}
        </Typography>
      )}
    </Stack>
  );
}
